import PropTypes from 'prop-types'
import { useState } from 'react'

import { AdasBox, AdasButton, AdasTextField } from '@components/wrapper-components'
import { updateUser } from '../../../../api/api'
import { phoneNumberFormat } from '../../../../utils/utils'

export const PhoneNumberForm = ({ user, close, onSaveSuccess }) => {
  const [newPhone, setNewPhone] = useState(user.phone ? user.phone : '')

  const handleInputChange = (e) => {
    const value = phoneNumberFormat(e.target.value)
    setNewPhone(value)
  }

  const handleSavePhoneNumber = () => {
    const data = { ...user, phone: newPhone }
    const updateUserResponse = updateUser({
      data: data
    })
    updateUserResponse.then((response) => {
      if (response.status === 200) {
        close()
        onSaveSuccess(data)
      }
    })
  }

  return (
    <AdasBox className='mt-4'>
      <AdasTextField
        placeholder='Phone'
        type='text'
        id='phone'
        label='Phone'
        className='w-full pb-2'
        onChange={handleInputChange}
        value={newPhone}
      />
      <AdasBox className='flex justify-end my-[20px] mx-0'>
        <AdasButton variant='outlined' aria-label='cancel' color='primary' onClick={close}>
          Cancel
        </AdasButton>
        <AdasButton
          type='submit'
          disabled={newPhone.length < 14}
          variant='contained'
          aria-label='save'
          color='primary'
          className='ml-2'
          onClick={handleSavePhoneNumber}
        >
          Save
        </AdasButton>
      </AdasBox>
    </AdasBox>
  )
}

PhoneNumberForm.propTypes = { user: PropTypes.object, close: PropTypes.func.isRequired, onSaveSuccess: PropTypes.func.isRequired }
